import { Dialog, DialogContent, DialogTitle, Box, Typography, Button } from '@mui/material';

import useStatusChange from './useStatusChange';
import { MuiStyledSelect } from '../../../shared/muiControls';

const StatusChange = ({ open, statusObj, statementId, currentStatus, handleClose = () => null, ...restOfProps }) => {
    const {
        //States
        isDoingAjax,
        newStatus,
        error,
        showError,

        //Handlers
        handleSaveClick,
        handleCloseClick,
        handleStatusChange,

        //Styles objects & functions
        styles,
    } = useStatusChange();

    return (
        <Dialog
            open={open}
            {...restOfProps}
        >
            <DialogTitle>Change annual statement status</DialogTitle>
            <DialogContent>
                <Box
                    sx={styles?.instructionSx}
                    id="instructions"
                >
                    <Typography>
                        Select the desired status for the statement and click{' '}
                        <Box
                            component="span"
                            sx={styles?.blueTextSx}
                        >
                            Update Status
                        </Box>{' '}
                        to save your changes.
                    </Typography>

                    <Typography>Current Status: {statusObj}</Typography>
                </Box>

                <Box sx={styles?.contentBoxSx}>
                    <MuiStyledSelect
                        required
                        label="New Status:"
                        value={newStatus}
                        error={showError && error}
                        onChange={(e) => handleStatusChange(e?.target?.value || '')}
                        disabled={isDoingAjax}
                    >
                        {/* TODO Pull these statuses from the database. */}
                        {[
                            {
                                id: 1,
                                value: 3,
                                label: 'Submitted',
                                disabled: currentStatus === 3,
                            },
                            {
                                id: 2,
                                value: 4,
                                label: 'Approved',
                                disabled: currentStatus === 4,
                            },
                        ]}
                    </MuiStyledSelect>
                </Box>

                <Box>
                    <Button
                        onClick={() => handleCloseClick(handleClose)}
                        disabled={isDoingAjax}
                        variant="contained"
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => handleSaveClick(handleClose, statementId)}
                        disabled={isDoingAjax}
                        variant="contained"
                    >
                        Update Status
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default StatusChange;
